import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DeviceIndexComponent } from './index';
import { CanActivateGuard } from './../shared/index';

export const DeviceRoutes: Routes = [
    {
        path: 'devices',
        component: DeviceIndexComponent,
        canActivate: [CanActivateGuard]
    },
];

export const DeviceRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(DeviceRoutes);
